import Vue from 'vue'
import Vuex from 'vuex'
import axiosCacheModule from './axiosCacheModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    cache: axiosCacheModule,
  },
})
